export const TITLE_CELL_WIDTH = 450;
export const ACTION_CELL_WIDTH = 48;
